import { CheckCircle, Users, Target, Award } from "lucide-react"

export function WhyChooseUs() {
  const features = [
    {
      icon: <CheckCircle className="w-5 h-5" />,
      text: "End-to-End Solutions: From ideation to execution, we handle it all.",
    },
    {
      icon: <Users className="w-5 h-5" />,
      text: "Experienced Team: A team of experts passionate about delivering excellence.",
    },
    {
      icon: <Target className="w-5 h-5" />,
      text: "Client-Focused Approach: Your goals are our priority.",
    },
    {
      icon: <Award className="w-5 h-5" />,
      text: "Affordable Pricing: Premium services at competitive rates.",
    },
  ]

  return (
    <section className="bg-gradient-to-r from-blue-600 to-blue-700 py-10 sm:py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Left side - Photo grid */}
          <div className="relative order-2 lg:order-1">
            <div className="grid grid-cols-3 gap-2 sm:gap-4 max-w-md mx-auto lg:mx-0">
              <div className="aspect-square rounded-lg overflow-hidden bg-gray-200">
                <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&q=80" alt="Team collaboration" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden bg-gray-200">
                <img src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400&q=80" alt="Web development" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden bg-gray-200">
                <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&q=80" alt="Business meeting" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden bg-gray-200">
                <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80" alt="Digital solutions" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden bg-gray-200 relative">
                <img src="https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&q=80" alt="Strategy" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-blue-900/40 rounded-lg" />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden bg-gray-200">
                <img src="https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?w=400&q=80" alt="Design workspace" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden bg-gray-200">
                <img src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=400&q=80" alt="Innovation" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden bg-gray-200">
                <img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&q=80" alt="Office" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square rounded-lg overflow-hidden bg-gray-200">
                <img src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&q=80" alt="Technology" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>

          {/* Right side - Content */}
          <div className="text-white order-1 lg:order-2 text-center lg:text-left">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4">Why Choose Us?</h2>
            <p className="text-blue-100 mb-6 sm:mb-8 text-base sm:text-lg">Your Path to Digital Success</p>

            <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 sm:gap-4 group hover:bg-white/10 p-3 rounded-lg transition-all duration-300"
                >
                  <div className="text-blue-200 group-hover:text-white transition-colors duration-300 mt-1 flex-shrink-0">
                    {feature.icon}
                  </div>
                  <p className="text-blue-100 group-hover:text-white transition-colors duration-300 leading-relaxed text-sm sm:text-base">
                    {feature.text}
                  </p>
                </div>
              ))}
            </div>

            <button className="bg-white text-blue-600 hover:bg-blue-50 font-semibold px-6 py-2.5 sm:px-8 sm:py-3 rounded-lg transition-all duration-300 hover:scale-105 flex items-center mx-auto lg:mx-0">
              Get Started Today
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
